export default __webpack_public_path__ + "static/media/cleaning.45a00101.svg";